document.addEventListener('DOMContentLoaded', function(){
  Array.from(document.getElementsByClassName('modal')).forEach((elem)=>{
    elem.addEventListener('hide.bs.modal', function(){ document.activeElement.blur(); });  
  });
});
